(function() {
  'use strict';
  angular.module('ringbaPortal').controller('ColumnToggleController', ColumnToggleController);

  function ColumnToggleController(
    _,
    $scope,
    $translate,
    columnsFetchService,
    userSettingsService
  ) {
    'ngInject';

    const vm = this;

    vm.saveColumnVisibility = saveColumnVisibility;

    // Defer $watch setup to $onInit so that the '@' binding for tableName
    // is resolved. In Webpack 5 builds, bindToController '@' bindings may
    // not be available during the controller constructor.
    vm.$onInit = function() {
      $scope.$watch('vm.userSettings.' + vm.tableName + '.columnSettings', function() {
        _.merge(vm.columnSettings, vm.userSettings && vm.userSettings[vm.tableName] &&
                     vm.userSettings[vm.tableName].columnSettings);
        _columnSettingsChanged();
      });
    };

    function saveColumnVisibility (columnSetting){
      columnSetting.hide = !columnSetting.hide;
      vm.columnSettings[columnSetting['name']].hide = columnSetting.hide;
      const newSettings = {
        hide: columnSetting.hide
      };
      if (!vm.userSettings) {
        userSettingsService.getUserSettings()
          .then(function (userSettings){
            vm.userSettings = userSettings;
            _saveColumnSettings(vm.userSettings, columnSetting['name'], newSettings);
          });
      } else {
        _saveColumnSettings(vm.userSettings, columnSetting['name'], newSettings);
      }
    }

    function _saveColumnSettings(userSettings, name, settings) {
      if (!userSettings[vm.tableName]) {
        userSettings[vm.tableName] = {};
      }
      userSettings[vm.tableName].columnSettings = userSettings[vm.tableName].columnSettings || {};
      // userSettings[vm.tableName].columnSettings = {};
      userSettings[vm.tableName].columnSettings[name] = settings;
      return userSettingsService.saveUserSettings(userSettings);
    }

    function _columnSettingsChanged() {
      vm.tempColumnSettings = _.cloneDeep(vm.columnSettings);
      const copyColumnSettings = _.cloneDeep(vm.columnSettings);

      vm.tempColumnSettings = _.reduce(vm.tempColumnSettings, function(result, value, key) {
        if (copyColumnSettings[key]) {
          if (copyColumnSettings[key]['hideForUserType'] && columnsFetchService.hideForUser(copyColumnSettings[key]['hideForUserType'])) {
            return result;
          }
          value['name'] = key;
          result.push(value);
        } else {
          delete vm.columnSettings[key];
        }
        return result;
      }, []);

      vm.tempColumnSettings = _.sortBy(vm.tempColumnSettings, function (o) {
        return $translate.instant(o.displayName) || o.displayName;
      });
    }
  }
})();
